import classes from '@/components/Award/Award.module.scss';
import { linkToString } from '@/helper/urls';
import Image from 'next/image';
import Link from 'next/link';
import type { ReactNode } from 'react';

export type AwardProps = {
  link?: string;
  subtitle?: string;
  description?: string;
} & (
  | {
      src: string;
      alt: string;
      image?: never;
    }
  | {
      src?: never;
      alt?: never;
      image: ReactNode;
    }
);

const Award: React.FC<AwardProps> = (props) => {
  const link = linkToString(props.link);
  return (
    <figure className={classes.award}>
      <div className={classes.awardImageWrapper}>
        {link ? (
          <Link prefetch={false} className={classes.awardLink} href={link}>
            {props.src && props.alt && <Image className={classes.awardImage} src={props.src} alt={props.alt} fill />}
            {props.image}
          </Link>
        ) : (
          <>
            {props.src && props.alt && <Image className={classes.awardImage} src={props.src} alt={props.alt} fill />}
            {props.image}
          </>
        )}
      </div>
      {(props.description || props.subtitle) && (
        <figcaption className={classes.awardDescription}>
          {props.subtitle && <h6 className={classes.awardSubtitle}>{props.subtitle}</h6>}
          {props.description && <div className="font-label">{props.description}</div>}
        </figcaption>
      )}
    </figure>
  );
};
export default Award;
